;(function($) {
    $(document).ready(function() {
        /* BEGIN: SLIDE BAR - RESPONSIVE MENU */
        $.slidebars({
            disableOver: 1200,
            siteClose: false
        });
        $('#responsive-menu ul li.menu-item-has-children').children("a").append('  <i class="fa fa-chevron-down"></i>');
        $('#responsive-menu ul li.menu-item-has-children').children("a").click(function(e) {
            e.preventDefault();
            if ($(this).parent().children('.sub-menu:first').is(':visible')) {
                $(this).parent().children('.sub-menu:first').hide();
            } else {
                $(this).parent().children('.sub-menu:first').show();
            }
        });
        /* END: SLIDE BAR - RESPONSIVE MENU */
        /* BEGIN - SEARCH LAYER */
        $('.search-icon a i').tooltip({
            trigger: "hover"
        });
        $('a[href="#search"]').on('click', function(event) {
            event.preventDefault();
            $('#search').addClass('open');
            $('#search > form > input[type="search"]').focus();
        });
        $('#search, #search button.close').on('click keyup', function(event) {
            if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                $(this).removeClass('open');
            }
        });
        /* END - SEARCH LAYER */
        /* BEGIN - CUSTOMER FILTER BY BUSINESS */
        $('#filter-by-class li a').click(function() {
            event.preventDefault();
            var className = $(this).attr('class');
            var clientContainer = $('#clients-collection .client-container');
            if (className == 'all') {
                clientContainer.fadeIn("slow");
            } else {
                $(".client-container")
                    .fadeOut(100)
                    .delay(100)
                    .filter(function() {
                        return $(this).html().indexOf(className) > -1;
                    })
                    .each(function(index, item) {
                        $(item).fadeIn("slow");
                    });
            }
            $('#filter-by-class li a').removeClass("active");
            $(this).addClass("active");
        });
        /* END - CUSTOMER FILTER BY BUSINESS */

        /* BEGIN - COLUMNS WITH SAME HEIGHT */
        function bootstrap_equalizer() {
            $(".equalizer").each(function() {
                var heights = $(this).find(".same-height").map(function() {
                        return $(this).height();
                    }).get(),

                    maxHeight = Math.max.apply(null, heights);

                $(".same-height").height(maxHeight);
            });
        }
        bootstrap_equalizer();
        /* END - COLUMNS WITH SAME HEIGHT */

        /* BEGIN - FOOTER MENU WITH ARROWS */
        $('.marketing-navigation ul li a').addClass('btn btn-link btn-arrow-right');
        /* END - FOOTER MENU WITH ARROWS */

        /* BEGIN - CUSTOMERS GRID - SLICK CAROUSEL */
        $('.responsive').slick({
            rows: 2,
            variableWidth: true,
            variableHeight: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 1500,
            speed: 1000,
            slidesToShow: 4,
            slidesToScroll: 4,
            centerMode: true,
            prevArrow: '<i class="customer-nav fa fa-chevron-left"></i>',
            nextArrow: '<i class="customer-nav fa fa-chevron-right"></i>'
        });
        /* END- CUSTOMERS GRID - SLICK CAROUSEL */

        /* BEGIN - FANCYBOX */
        $(".gallery").each(function(e, t) {
            gal = $(t), $("a", gal).each(function(t, n) {
                $(n).attr("rel", "gal-" + e + "")
            })
        });
        $("a.ampliar, a.gal, div.gallery a").fancybox({
            helpers: {
                overlay: {
                    opacity: 0.3,
                    css: {
                        'background': 'rgba(0, 0, 0, 0.60)'
                    }
                } // overlay 
            } // helpers
        });
        /* END - FANCYBOX */
        /* BEGIN - 404 Page */
        $('.coruja404.step2').hide();
        $("#coruja-trigger").click(function() {
            //alert('ok');
            $('.coruja404.step1').hide();
            $('.coruja404.step2').show();
            window.setTimeout(function() {
                window.location.href = '/';
            }, 700);
        });
        /* END - 404 Page */
    $('#goTop').goTop();
    });
})(jQuery);